const attachmentOrigins = [
    { value: "inperson", label: "In Person" },
    { value: "email", label: "Email" },
    { value: "postalmail", label: "Postal Mail" },
    { value: "whatsapp", label: "WhatsApp" },
    { value: "other", label: "Other" },
    { value: "analysis", label: "Analysis", excludeFromSelect: true },
];
export default attachmentOrigins;